// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89d2ceb7","726":"2cd7c162"}[chunkId] + ".chunk.js";
};